export enum RegexEnum {
  REGEX_PASSWORD_COMPLEXITY = '^.*(?=.{8,})(?=.*[a-zA-Z\\\u0080-\\\uFFFF])(?=.*\\d).*$',
  REGEX_URL = '^https?:\\/\\/(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_\\+.~#?&//=]*)',
  REGEX_INTEGER = '^(0|[1-9][0-9]*)$',
  REGEX_NOT_WILDCARD = '[*]{2,}',
  REGEX_MO = '^[(\\w+)0-9+?\\*?\\_?\\:?\\&\\-\\.\\ ]*$',
  REGEX_ESI = '^[0-9+-?*]*$',
  REGEX_LAT = '^(-?[1-8]?\\d(?:\\.\\d{1,18})?|90(?:\\.0{1,18})?)$',
  REGEX_LONG = '^(-?(?:1[0-7]|[1-9])?\\d(?:\\.\\d{1,18})?|180(?:\\.0{1,18})?)$',
  REGEX_NOT_SLASH = '/',
}
